"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrphanBoundaries = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const ExpressionExpansion_1 = require("../ExpressionExpansion");
const boundary_facts_1 = require("./boundary-facts");
class OrphanBoundaries {
    static kindClass(kind) {
        switch (kind) {
            case ExpressionExpansion_1.RatingsKind.Amr: {
                return sigma_engine_shared_1.BoundaryClass.IC_AbsoluteMaximumRating;
            }
            case ExpressionExpansion_1.RatingsKind.Oc: {
                return sigma_engine_shared_1.BoundaryClass.IC_ElectricalCharacteristics;
            }
        }
    }
    static isOfKind(bound, kind) {
        return bound.boundary.class === OrphanBoundaries.kindClass(kind);
    }
    static isStatableByRow(bound) {
        const definition = bound.boundary;
        if (!sigma_engine_shared_1.DesignModels.isBoundaryNumericalDefinition(definition)) {
            return false;
        }
        const { numerical } = definition;
        return (sigma_engine_shared_1.RatedBoundaryCharacteristics.includes(numerical.characteristic) &&
            (definition.strength === undefined || definition.strength === sigma_engine_shared_1.BoundaryAssertionStrength.None) &&
            (numerical.variance === undefined || numerical.variance === '') &&
            numerical.useAbsVal !== true &&
            !(numerical.type === 'range' && numerical.rangeMode === 'exclusive') &&
            !OrphanBoundaries.namesSeveralSignals(definition.relative_to) &&
            !(bound.conditions ?? []).some((condition) => sigma_engine_shared_1.DesignModels.isModeReferenceCondition(condition) && !condition.mode_state));
    }
    static expandRows(rows, context) {
        return Object.fromEntries(rows.map((row) => [row.id, ExpressionExpansion_1.RatingExpansionEngine.expand(row, context)]));
    }
    static statedBounds(rows, context) {
        const kindClass = OrphanBoundaries.kindClass(context.kind);
        return rows.flatMap((row) => boundary_facts_1.BoundaryFacts.apply(ExpressionExpansion_1.RatingExpansionEngine.expand(row, context).bounds, row.overrides).map((bound) => bound.boundary.class === undefined ? { ...bound, boundary: { ...bound.boundary, class: kindClass } } : bound));
    }
    static find(rows, context, boundaries, deletedBoundaryIds) {
        const stated = OrphanBoundaries.statedFacts(rows, context);
        const deleted = new Set(deletedBoundaryIds);
        return boundaries.filter((bound) => !deleted.has(bound.id) &&
            OrphanBoundaries.isOfKind(bound, context.kind) &&
            !OrphanBoundaries.isCovered(bound, stated, context));
    }
    static covered(rows, context, boundaries) {
        const stated = OrphanBoundaries.statedFacts(rows, context);
        return boundaries.filter((bound) => OrphanBoundaries.isOfKind(bound, context.kind) && OrphanBoundaries.isCovered(bound, stated, context));
    }
    static rowsNeedingReference(rows, expansions) {
        return rows
            .filter((row) => row.characteristic === sigma_engine_shared_1.BoundaryCharacteristic.Voltage &&
            OrphanBoundaries.lacksReference(row.relative) &&
            expansions[row.id]?.status === ExpressionExpansion_1.ExpansionStatus.Unrecognized)
            .map((row) => row.id);
    }
    static namesSeveralSignals(reference) {
        return (reference !== undefined && 'signal' in reference && Array.isArray(reference.signal) && reference.signal.length > 1);
    }
    static lacksReference(relative) {
        if (relative === null) {
            return true;
        }
        switch (relative.kind) {
            case ExpressionExpansion_1.RatingsRelativeReferenceKind.Signal: {
                return relative.signalId === null;
            }
            case ExpressionExpansion_1.RatingsRelativeReferenceKind.Mapping: {
                return relative.pairs.some((pair) => pair.relativeId === null);
            }
        }
    }
    static statedFacts(rows, context) {
        return boundary_facts_1.BoundaryFacts.fromBoundaries(OrphanBoundaries.statedBounds(rows, context).filter((bound) => OrphanBoundaries.isOfKind(bound, context.kind) && OrphanBoundaries.isStatableByRow(bound)), context.signals);
    }
    static isCovered(bound, stated, context) {
        if (!OrphanBoundaries.isStatableByRow(bound)) {
            return false;
        }
        const facts = boundary_facts_1.BoundaryFacts.fromBoundaries([bound], context.signals);
        return boundary_facts_1.BoundaryFacts.factsEqual([...stated, ...facts], stated);
    }
}
exports.OrphanBoundaries = OrphanBoundaries;
//# sourceMappingURL=orphan-boundaries.js.map